import { CircularProgress, useMediaQuery } from "@mui/material";
import IndieButton from "./IndieButton";

const { Save } = require("@mui/icons-material");
const { useTranslation } = require("react-i18next")

const IndieSaveButton = ({label, loading, useAuthTests, ...params}) => {

    const { t } = useTranslation();
    const isUpSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

    return <IndieButton 
        useAuthTests={useAuthTests} 
        startIcon={loading ? <CircularProgress color="inherit" size={18} /> : <Save data-testid="SaveIcon" />} 
        variant="outlined"
        color="primary" {...params}>
            {isUpSm && (label ? label : t("label.button.save"))}
        </IndieButton>
}

export default IndieSaveButton;